"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfScheduleAvailabilityDateDto = instanceOfScheduleAvailabilityDateDto;
exports.ScheduleAvailabilityDateDtoFromJSON = ScheduleAvailabilityDateDtoFromJSON;
exports.ScheduleAvailabilityDateDtoFromJSONTyped = ScheduleAvailabilityDateDtoFromJSONTyped;
exports.ScheduleAvailabilityDateDtoToJSON = ScheduleAvailabilityDateDtoToJSON;
exports.ScheduleAvailabilityDateDtoToJSONTyped = ScheduleAvailabilityDateDtoToJSONTyped;
const ShiftTime_1 = require("./ShiftTime");
/**
 * Check if a given object implements the ScheduleAvailabilityDateDto interface.
 */
function instanceOfScheduleAvailabilityDateDto(value) {
    if (!('date' in value) || value['date'] === undefined)
        return false;
    if (!('shiftTime' in value) || value['shiftTime'] === undefined)
        return false;
    if (!('startTime' in value) || value['startTime'] === undefined)
        return false;
    if (!('endTime' in value) || value['endTime'] === undefined)
        return false;
    return true;
}
function ScheduleAvailabilityDateDtoFromJSON(json) {
    return ScheduleAvailabilityDateDtoFromJSONTyped(json, false);
}
function ScheduleAvailabilityDateDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'date': json['date'],
        'shiftTime': (0, ShiftTime_1.ShiftTimeFromJSON)(json['shiftTime']),
        'startTime': json['startTime'],
        'endTime': json['endTime'],
    };
}
function ScheduleAvailabilityDateDtoToJSON(json) {
    return ScheduleAvailabilityDateDtoToJSONTyped(json, false);
}
function ScheduleAvailabilityDateDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'date': value['date'],
        'shiftTime': (0, ShiftTime_1.ShiftTimeToJSON)(value['shiftTime']),
        'startTime': value['startTime'],
        'endTime': value['endTime'],
    };
}
//# sourceMappingURL=ScheduleAvailabilityDateDto.js.map